import {Button, Card, Col, Container, Row} from "react-bootstrap";
import React from "react";
import {useNavigate} from "react-router-dom";
import './Features.css';
import {useTranslation} from "react-i18next";

const Features = () => {
    const {t} = useTranslation();
    const navigate = useNavigate(); // Hook for programmatic navigation

    const cardData = [
        {
            title: t("pages.home.features.1.title"),
            description: t("pages.home.features.1.description"),
            buttonLabel: t("pages.home.features.1.buttonLabel"),
            icon: t("pages.home.features.1.icon"),
            link: t("pages.home.features.1.link")
        },
        {
            title: t("pages.home.features.2.title"),
            description: t("pages.home.features.2.description"),
            buttonLabel: t("pages.home.features.2.buttonLabel"),
            icon: t("pages.home.features.2.icon"),
            link: t("pages.home.features.2.link")
        },
        {
            title: t("pages.home.features.3.title"),
            description: t("pages.home.features.3.description"),
            buttonLabel: t("pages.home.features.3.buttonLabel"),
            icon: t("pages.home.features.3.icon"),
            link: t("pages.home.features.3.link")
        },
    ];

    return (
        <Container className="my-5" id="features">
            <Row className="g-4">
                {cardData.map((card, index) => (
                    <Col md={4} key={index} className="d-flex">
                        <Card className="text-center border-0 flex-fill d-flex flex-column border-radius-15px">
                            <Card.Body className="d-flex flex-column">
                                <div className={"card-icon"}>{card.icon}</div>
                                <Card.Title className={"fw-bold"}>{card.title}</Card.Title>
                                <Card.Text className={"flex-grow-1 color-6c757d-2"}>{card.description}</Card.Text>
                                <Button
                                    variant="primary"
                                    className="mt-3 text-white"
                                    onClick={() => navigate(card.link)} // Navigate to the link
                                >
                                    {card.buttonLabel}
                                </Button>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Container>
    );
}

export default Features;
